<div class="ai-assistant-widget" [class.is-open]="open()">
  @if (open()) {
    <section class="panel" role="dialog" [attr.aria-label]="'aiMarketing.nav.assistant' | t">
      <div class="panel-head">
        <h2 class="panel-title">{{ 'aiMarketing.nav.assistant' | t }}</h2>
        <button type="button" class="panel-close" (click)="close()" [attr.aria-label]="'common.close' | t">
          ×
        </button>
      </div>
      <app-ai-marketing-assistant [embedded]="true" />
    </section>
  } @else {
    <button
      type="button"
      class="launcher"
      (click)="toggle()"
      [attr.aria-label]="'aiMarketing.assistant.launcher' | t"
      [title]="'aiMarketing.assistant.launcher' | t"
    >
      <span class="material-symbols-outlined" aria-hidden="true">auto_awesome</span>
    </button>
  }
</div>
